import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperationalStatusBuilder } from '../../models/builders/operational-status.builder';

@Injectable()
export class ProductionManagementsApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}production-managements`;
  }

  getOperationalStatuses() {
    return this.httpClient.get(`${this.apiUrl}/statuses`)
      .pipe(
        map(OperationalStatusBuilder.fromList)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/production-managment-api.service.ts